import styled from "@emotion/native";

export const Selections = styled.View({
	flexDirection: "column",
	justifyContent: "center",
	alignContent: "center",
	alignItems: "center",
	marginTop: 60,
});
